import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppState from "./context/AppState";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css';
import 'leaflet-defaulticon-compatibility';
import '../src/assets/fonts/font.css'
const root = ReactDOM.createRoot(document.getElementById("root"));



root.render(
  
  <React.StrictMode>
    <BrowserRouter>
    <AppState>
      <App />
    </AppState>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
